import {DOCUMENT_TYPE_BANK_FRONTPAGE} from '@/modules/finkn/field-of-area/bank/frontpage/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_FRONTPAGE} from '@/modules/finkn/field-of-area/collection/frontpage/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_FRONTPAGE} from '@/modules/finkn/field-of-area/insurance/frontpage/sanity/constants';
import type {FieldOfAreaFilters} from '@/modules/finkn/shared/components/filters/category-filters';
import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import {ARTICLE_PAGE_SIZE} from '@/shared/constants';

import type {ArticleDetails} from '../../shared/types';
import {DOCUMENT_TYPE_ARTICLE} from '../constants';
import {ARTICLE_IN_CARD_FRAGMENT, articleInCardFragmentToArticleDetails} from '../query';

import type {BLOCK_TYPE_ARTICLE_LIST_ALL} from './constants';

export const ARTICLE_LIST_ALL_FRAGMENT = `//groq
	...,
	"articles": *[_type == "${DOCUMENT_TYPE_ARTICLE}"] | order(coalesce(publishDate, _createdAt) desc) [0...${ARTICLE_PAGE_SIZE}] {
			${ARTICLE_IN_CARD_FRAGMENT}
	},
	"totalArticles": count(*[_type == "${DOCUMENT_TYPE_ARTICLE}"]),
	"fieldOfAreaFilters": *[_type == "${DOCUMENT_TYPE_INSURANCE_FRONTPAGE}" || _type == "${DOCUMENT_TYPE_BANK_FRONTPAGE}" || _type == "${DOCUMENT_TYPE_COLLECTION_FRONTPAGE}"] {
		"slug": slug.current,
		"title": title,
		_id
	}
`;

export type ArticleListAllFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_ARTICLE_LIST_ALL}
>;

type ArticleListFromArticleListAllSectionType = {
	articles: KeyedArray<ArticleDetails>;
	fieldOfAreaFilters: FieldOfAreaFilters[];
	totalArticles: number;
};

export const articleListFromArticleListAllSection = (
	section: ArticleListAllFragment,
): ArticleListFromArticleListAllSectionType => {
	const articles: KeyedArray<ArticleDetails> = [];

	if (!section.articles?.length) {
		return {articles, fieldOfAreaFilters: [], totalArticles: 0};
	}

	const fieldOfAreaFilters: FieldOfAreaFilters[] = [];

	for (const fieldOfArea of section.fieldOfAreaFilters ?? []) {
		if (fieldOfArea?.slug && fieldOfArea.title) {
			fieldOfAreaFilters.push({
				title: fieldOfArea.title,
				slug: fieldOfArea.slug,
				_id: fieldOfArea._id,
			});
		}
	}

	for (const articleInCard of section.articles) {
		if (articleInCard) {
			const article = articleInCardFragmentToArticleDetails(articleInCard);
			if (article) {
				articles.push({
					_key: articleInCard._id,
					...article,
				});
			}
		}
	}

	return {
		articles,
		fieldOfAreaFilters,
		totalArticles: section.totalArticles,
	};
};
